exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "what-is-solidary-euro{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryEuro.scss
// module id = 2251
// module chunks = 0